import { ref } from 'vue';

import { FontFamily } from '@/shared/components/types.ts';

export const useAppConfig = () => {
  const progressBarHeight = ref(30);
  const contentContainerTopPadding = ref(45);
  const contentContainerBottomPadding = ref(40);
  const contentContainerRightPadding = ref(55);
  const contentContainerLeftPaddingLarge = ref(55);
  const contentContainerLeftPaddingSmall = ref(24);
  const desktopSlideContainerBorderRadiusPx = ref('30px');
  const desktopSlideContainerHeightMargin = ref(36);
  const desktopSlideContainerHeightMarginPx = ref(`${desktopSlideContainerHeightMargin.value}px`);

  const fontFamily = ref<FontFamily>('Poppins');

  const theme = ref({
    dark: {
      defaultTextColor: '#fff',
    },
    light: {
      defaultTextColor: '#060401',
    },
  });

  const VOICEOVER_DELAY_PLAY = 1000;

  return {
    progressBarHeight,
    contentContainerTopPadding,
    contentContainerBottomPadding,
    contentContainerRightPadding,
    contentContainerLeftPaddingLarge,
    contentContainerLeftPaddingSmall,
    desktopSlideContainerBorderRadiusPx,
    desktopSlideContainerHeightMargin,
    desktopSlideContainerHeightMarginPx,

    theme,
    fontFamily,

    VOICEOVER_DELAY_PLAY,
  };
};
